
import Framer from "../../../assets/duotone/Framer.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FramerIcon({ className, dataTestid = "FramerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Framer data-testid={dataTestid} className={classes} {...rest} />
  );
}
